import {
  SET_CBP_REQUEST_MESSAGE,
  GET_CBP_REQUEST_MESSAGE_WATCHER,
  SET_CBP_REQUEST_MESSAGE_ERROR,
  SAVE_EDI_REQUEST_WATCHER,
  SET_SAVE_EDI_REQUEST_SUCCESS,
  SET_SAVE_EDI_REQUEST_ERROR,
  CREATE_EDI_REQUEST_WATCHER,
  SET_CREATE_EDI_REQUEST_SUCCESS,
  SET_CREATE_EDI_REQUEST_ERROR
} from "../actionTypes/index";

export const getCbpRequestMessageWatcher = (payload, resolve, reject) => {
  return { type: GET_CBP_REQUEST_MESSAGE_WATCHER, payload, resolve, reject };
};

export const setCbpRequestMessage = (payload, resolve, reject) => {
  return { type: SET_CBP_REQUEST_MESSAGE, payload, resolve, reject };
};

export const setCbpRequestMessageError = (payload, resolve, reject) => {
  return { type: SET_CBP_REQUEST_MESSAGE_ERROR, payload, resolve, reject };
};
/**
   *  
   * SAVE_EDI_REQUEST Action
   * 
   */
export const saveEdiRequestWatcher = (payload, resolve, reject) => {
  return { type: SAVE_EDI_REQUEST_WATCHER, payload, resolve, reject };
};

export const setSaveEdiRequestSuccess = (payload, resolve, reject) => {
  return { type: SET_SAVE_EDI_REQUEST_SUCCESS, payload, resolve, reject };
};

export const setSaveEdiRequestError = (payload, resolve, reject) => {
  return { type: SET_SAVE_EDI_REQUEST_ERROR, payload, resolve, reject };
};

export const createEdiRequestWatcher = (payload, resolve, reject) => {
  return { type: CREATE_EDI_REQUEST_WATCHER, payload, resolve, reject };
};

export const setCreateEdiRequestSuccess = (payload, resolve, reject) => {
  return { type: SET_CREATE_EDI_REQUEST_SUCCESS, payload, resolve, reject };
};

export const setCreateEdiRequestError = (payload, resolve, reject) => {
  return { type: SET_CREATE_EDI_REQUEST_ERROR, payload, resolve, reject };
};